import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { organisationTabCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_WORK_INSIGHTS_LOCATIONS,
  FETCH_WORK_INSIGHTS_LOCATIONS_ERROR,
  SET_WORK_INSIGHTS_LOCATIONS,
} from '../../constants';

const workInsightsLocations = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_WORK_INSIGHTS_LOCATIONS),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/work/locations?${
          organisationTabCriteria(state$)
        }${
          boundariesCriteria(state$)
        }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {

          return {
            type: SET_WORK_INSIGHTS_LOCATIONS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_WORK_INSIGHTS_LOCATIONS_ERROR,
            error,
          })
        )
      )
    )
  );

export default workInsightsLocations;
